import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonSecondary } from '@components/button';
import { BUTTON_VARIANT_S } from '@components/button/src/config';
import { SubmenuIcon } from '@components/submenu-with-icon';

import { EventHeaderActionsProps } from './event-header-actions.type';

export const EventHeaderActions = ({
  isPublished,
  isLiveEvent,
  isLessThanTablet,
  reportPath,
  publishedActions,
  unpublishedActions,
  buttonReportText,
  buttonPreviewText,
  buttonViewText,
  openPreview,
}: EventHeaderActionsProps) => {
  if (isPublished)
    return (
      <>
        {isLessThanTablet ? (
          <SubmenuIcon
            buttonClasses='rounded-md px-0 py-0 md:px-2 md:py-2 md:fill-tertiary text-action-button-s text-primary flex items-center gap-1 border-none'
            dotsClasses='w-5 h-5 dark:text-white'
            options={publishedActions}></SubmenuIcon>
        ) : isLiveEvent ? (
          <>
            <ButtonSecondary className='whitespace-nowrap' variant={BUTTON_VARIANT_S} onClick={() => openPreview()}>
              {buttonViewText}
            </ButtonSecondary>
            <SubmenuIcon
              buttonClasses='rounded-md px-0 py-0 md:px-2 md:py-2 md:fill-tertiary text-action-button-s text-primary flex items-center gap-1 border-none'
              dotsClasses='w-5 h-5 dark:text-black-900'
              options={publishedActions}></SubmenuIcon>
          </>
        ) : (
          <>
            <Link to={reportPath as string}>
              <ButtonSecondary className='whitespace-nowrap' variant={BUTTON_VARIANT_S}>
                {buttonReportText}
              </ButtonSecondary>
            </Link>
            <SubmenuIcon
              buttonClasses='rounded-md px-0 py-0 md:px-2 md:py-2 md:fill-tertiary text-action-button-s text-primary flex items-center gap-1 border-none'
              dotsClasses='w-5 h-5 dark:text-black-900'
              options={publishedActions}></SubmenuIcon>
          </>
        )}
      </>
    );
  return (
    <>
      {!isLessThanTablet && (
        <ButtonSecondary className='whitespace-nowrap' variant={BUTTON_VARIANT_S} onClick={() => openPreview()}>
          {buttonPreviewText}
        </ButtonSecondary>
      )}
      <SubmenuIcon
        buttonClasses='rounded-md px-0 py-0 md:px-2 md:py-2 md:fill-tertiary text-action-button-s text-primary flex items-center gap-1 border-none'
        dotsClasses='w-5 h-5'
        options={unpublishedActions}></SubmenuIcon>
    </>
  );
};
